/** Inline SVG-vlaggen — vlag-emoji's renderen niet op Windows-desktop. */
export function FlagNL({ className = "h-3.5 w-5" }: { className?: string }) {
  return (
    <svg viewBox="0 0 20 14" className={className} aria-hidden="true" role="img">
      <rect width="20" height="14" rx="2" fill="#fff" />
      <rect width="20" height="4.67" rx="2" fill="#AE1C28" />
      <rect y="4.67" width="20" height="4.66" fill="#fff" />
      <rect y="9.33" width="20" height="4.67" rx="2" fill="#21468B" />
    </svg>
  );
}

export function FlagGB({ className = "h-3.5 w-5" }: { className?: string }) {
  return (
    <svg viewBox="0 0 20 14" className={className} aria-hidden="true" role="img">
      <rect width="20" height="14" rx="2" fill="#012169" />
      <path d="M0 0l20 14M20 0L0 14" stroke="#fff" strokeWidth="2.5" />
      <path d="M0 0l20 14M20 0L0 14" stroke="#C8102E" strokeWidth="1.2" />
      <path d="M10 0v14M0 7h20" stroke="#fff" strokeWidth="4.2" />
      <path d="M10 0v14M0 7h20" stroke="#C8102E" strokeWidth="2.4" />
    </svg>
  );
}
